import WorkOrderStatusPill from '@atom/components/common/workOrderDetail/workOrderStatusPill/WorkOrderStatusPill';
import { Icon } from '@atom/mui';
import { WorkIcon } from '@atom/mui/icons';
import { MapWorkOrder } from '@atom/types/map';
import timeUtilities from '@atom/utilities/timeUtilities';
import { getWorkOrderStatusColor } from '@atom/utilities/workOrderStatusUtilities';

import classes from './list.module.css';

type WorkListItemProps = {
  workOrder: MapWorkOrder;
  onSelect: (id: string) => void;
  onHover?: (id: string | null) => void;
};

const WorkListItem = ({ workOrder, onSelect, onHover }: WorkListItemProps) => {
  const { id, name, statusId, dueDate, assigneeCount, taskCount } = workOrder;

  const iconStyle = {
    fontSize: '24px',
    color: getWorkOrderStatusColor(statusId),
  };

  return (
    <div
      className={classes.listItem}
      onClick={() => onSelect(id)}
      onMouseEnter={() => onHover?.(id)}
      onMouseLeave={() => onHover?.(null)}
    >
      <div className={classes.itemIcon}>
        <Icon style={iconStyle} icon={WorkIcon} />
      </div>
      <div className={classes.itemBody}>
        <div className={classes.itemTitle}>{name}</div>
        <div className={classes.statusPillRow}>
          <WorkOrderStatusPill
            statusId={statusId}
            className="dashboard-map-list"
          />
        </div>
        <div className={classes.itemDetails}>
          <div className={classes.itemDetail}>
            Due Date: {timeUtilities.setDisplayDate(dueDate)}
          </div>
          <div className={classes.itemDetail}>Team: {assigneeCount}</div>
          <div className={classes.itemDetail}>Tasks: {taskCount}</div>
        </div>
      </div>
    </div>
  );
};

export default WorkListItem;
